import {Dispatch, SetStateAction} from 'react'

import {CurrentMenuAccessModel} from 'app/context/models'

import {UserID} from '.'

export type ActionContextProps = {
  currentAccessMenu: CurrentMenuAccessModel | undefined
  setCurrentAccessMenu: Dispatch<SetStateAction<CurrentMenuAccessModel | undefined>>
  isLoading: boolean
  setIsLoading: Dispatch<SetStateAction<boolean>>
  showFilter: boolean
  setShowFilter: Dispatch<SetStateAction<boolean>>
  action: string
  setAction: Dispatch<SetStateAction<string>>
  userRoles: any
  setUserRoles: Dispatch<SetStateAction<any>>
  itemIdForUpdate?: UserID
  setItemIdForUpdate: Dispatch<SetStateAction<UserID>>
}

export const initialAction: ActionContextProps = {
  currentAccessMenu: undefined,
  setCurrentAccessMenu: () => {},
  isLoading: false,
  setIsLoading: () => {},
  showFilter: false,
  setShowFilter: () => {},
  action: '',
  setAction: () => {},
  userRoles: undefined,
  setUserRoles: () => {},
  setItemIdForUpdate: () => {},
}

export type UserRolesForInputAPIResponse<T> = {
  data?: T
}

export type UserRolesForInputModel = {
  role_id?: string | null | undefined
  name?: string | null | undefined
}

export type UserRolesForInputModelResponse = UserRolesForInputAPIResponse<
  Array<UserRolesForInputModel>
>
